

// import React, { useEffect, useState } from "react";

// const BannerCarousel = ({ images = [] }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Auto-slide every 5 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex(prev =>
//         prev === images.length - 1 ? 0 : prev + 1
//       );
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [images]);

//   if (!images.length) return null;

//   return (
//     <section className="relative w-full overflow-hidden bg-white">
//       <div className="w-full h-[300px] md:h-[450px] relative">
//         {images.map((img, idx) => (
//           <img
//             key={idx}
//             src={img}
//             alt={`Banner ${idx + 1}`}
//             className={`absolute top-0 left-0 w-full h-full object-fit transition-opacity duration-1000 ease-in-out rounded-lg shadow ${
//               idx === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
//             }`}
//           />
//         ))}

//         {/* Overlay */}
//         <div className="absolute inset-0 bg-black/30 z-20 rounded-lg" />

//         {/* Dots */}
//         <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 z-30 flex gap-2">
//           {images.map((_, idx) => (
//             <button
//               key={idx}
//               onClick={() => setCurrentIndex(idx)}
//               className={`w-3 h-3 rounded-full ${
//                 idx === currentIndex ? "bg-white" : "bg-white/50"
//               }`}
//             ></button>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BannerCarousel;


// src/components/School/BannerCarousel.jsx

import React, { useEffect, useState } from "react";

const BannerCarousel = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [images]);

  if (!images.length) return null;

  return (
    <section className="bg-white py-8">
      <div className="w-[90%] md:w-[80%] lg:w-[70%] mx-auto relative rounded-lg overflow-hidden shadow-lg">
        <div className="relative h-[250px] sm:h-[300px] md:h-[400px] lg:h-[450px]">
          {images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Banner ${idx + 1}`}
              className={`absolute top-0 left-0 w-full h-full object-fit transition-opacity duration-1000 ease-in-out ${
                idx === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
            />
          ))}

          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-black/30 z-20" />

          {/* Dots Navigation */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-30 flex gap-2">
            {images.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  idx === currentIndex ? "bg-white" : "bg-white/50"
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerCarousel;

